import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { FuncionalidadControl } from '../../../_models/funcionalidad-control';
import { UtilitiesService } from '../../../utils/utilities.service';
import { AppSettings } from '../../../../proyect.conf';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ConstanteService } from '../../../_services/constante.service';
import { FlujoVentaPasoVinculacion } from '../../../_models/flujo-venta-paso-vinculacion';
import { FlujoVentaPasoVinculacionService } from '../../../_services/flujo-venta-paso-vinculacion.service';
import { FlujoVentaPasoService } from '../../../_services/flujo-venta-paso.service';
import { ListaItem } from '../../../_models/lista-item';
import { ListaService } from '../../../_services/lista.service';
import { FlujoVentaPasoAdjunto } from '../../../_models/flujo-venta-paso-adjunto';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { FlujoVentaPasoAdjuntoService } from '../../../_services/flujo-venta-paso-adjunto.service';
import { FlujoVentaPasoControlService } from '../../../_services/flujo-venta-paso-control.service';
import { FlujoVentaPasoControl } from '../../../_models/flujo-venta-paso-control';
import { ComunicationComponentsService } from '../../../_services/comunication-components.service';
import { TabViewCustom } from '../../../_models/tab-view-custom';
import { AdjuntoService } from '../../../_services/adjunto.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {Pasos} from '../../../_enums/enum';
import {scrollToFirstInvalidControl} from '../../../utils/utilidades';
import {FlujoVentaPasoTiposPersonas} from '../../../_models/flujo-venta-paso-tipos-personas';
import {list} from '../../../_models/gestor-centralizado';
import {FlujoVentaPasoTiposPersonasService} from '../../../_services/flujo-venta-paso-tipos-personas.service';
import {FlujoVentaPasoOcupacion} from '../../../_models/flujo-venta-paso-ocupacion';
import {FlujoVentaPasoOcupacionService} from '../../../_services/flujo-venta-paso-ocupacion.service';
import {TipoOcupacionConfiguracion} from '../../../_models/tipo-ocupacion-configuracion';
import {TipoOcupacionConfiguracionService} from '../../../_services/tipo-ocupacion-configuracion.service';

@Component( {
  selector: 'app-flujo-venta-tab-view',
  templateUrl: 'flujo-venta-tab-view.component.html'
} )

export class FlujoVentaTabViewComponent implements OnInit, OnDestroy {

  @ViewChild('flujoVentaForm') flujoVentaFormRef: ElementRef<HTMLFormElement>;
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() showControlesTable: boolean;
  @Input() esAcordeon: boolean;
  @Input() HabilitarindicadorVinculacionPorPerfil: boolean = false;
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Output() goNextAccordion: EventEmitter<any> = new EventEmitter<any>();
  funcionalidadControl: FuncionalidadControl;
  flujoVentaPasoModel: FlujoVentaPaso;
  flujoVentaPasoVinculaciones: FlujoVentaPasoVinculacion[] = [];
  flujoVentaPasoAdjunto: FlujoVentaPasoAdjunto;
  flujoVentaPasoTiposPersonas: FlujoVentaPasoTiposPersonas[] = [];
  flujoVentaPasoOcupaciones: FlujoVentaPasoOcupacion[] = [];
  listaTiposOcupacionesConfig: SelectItem[] = [];
  secuenciaVieja: number;
  public cargando = true;
  public procesando = false;
  public formFlujoVentaPaso: FormGroup;
  public formSubmitted = false;
  public subAdjunto = false;
  public fsize = 50000000;
  public ftype = '';
  public svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  public nomArchivo = '';
  public submitAdjunto = false;
  public guardando = false;
  public inhabilitarBotonGuardar = false;
  get f() {
    return this.formFlujoVentaPaso.controls;
  }

  suscripcionCambioSecuencia: Subscription;
  realizarBusquedaDatatable: BehaviorSubject<any> = new BehaviorSubject<any>( null );
  imagen: SafeResourceUrl;
  tempFile: any;
  file: any;

  constructor( private fb: FormBuilder,
               private navService: NavService,
               private utilitiesService: UtilitiesService,
               private authService: AutenticacionService,
               private constanteService: ConstanteService,
               private confirmService: ConfirmationService,
               private flujoVentaPasoVinculacionService: FlujoVentaPasoVinculacionService,
               private flujoVentaPasoService: FlujoVentaPasoService,
               private listaService: ListaService,
               private flujoVentaPasoAdjuntoService: FlujoVentaPasoAdjuntoService,
               private componentCommService: ComunicationComponentsService,
               private sanitizer: DomSanitizer,
               private adjService: AdjuntoService,
               private flujoVentaPasoTiposPersonasService: FlujoVentaPasoTiposPersonasService,
               private flujoVentaPasoOcupacionService: FlujoVentaPasoOcupacionService,
               private tipoOcupacionConfiguracionService: TipoOcupacionConfiguracionService) {
  }

  ngOnInit() {
    this.flujoVentaPasoModel = this.tabView ? this.tabView.flujoVenta : null;
    this.funcionalidadControl = this.tabView ? this.tabView.seccion : null;
    this.secuenciaVieja = this.flujoVentaPasoModel ? this.flujoVentaPasoModel.secuencia : null;

    this.conectarCanal();

    this.constanteService.getByCode( 'FTYPE' ).subscribe( data => {
      if ( data && data.valor ) {
        this.ftype = data.valor;
      }
    } );
    this.constanteService.getByCode( 'FSIZE' ).subscribe( data => {
      if ( data && data.valor ) {
        this.fsize = Number( data.valor );
      }
    } );
    this.tipoOcupacionConfiguracionService.listadoHabilitados().subscribe( tipos => {
      this.listaTiposOcupacionesConfig = tipos.map( t => ( { label: t.codigoTipoOcupacion + ' - ' + t.nombreTipoOcupacion, value: t.idTipoOcupacionConfiguracion } ) );
    } );

    if ( this.flujoVentaPasoModel ) {
      forkJoin(
        this.flujoVentaPasoAdjuntoService.obtenerPorIdFlujoVentaPaso( this.flujoVentaPasoModel.idFlujoVentaPaso ),
        this.flujoVentaPasoVinculacionService.listadoPorIdFlujoPaso( this.flujoVentaPasoModel.idFlujoVentaPaso ),
        this.flujoVentaPasoTiposPersonasService.listadoPorIdFlujoPaso( this.flujoVentaPasoModel.idFlujoVentaPaso ),
        this.flujoVentaPasoOcupacionService.listadoPorIdFlujoPaso( this.flujoVentaPasoModel.idFlujoVentaPaso )
      ).subscribe( ( [ adjunto, vinculaciones, naturaleza, ocupaciones ] ) => {
        this.flujoVentaPasoVinculaciones = vinculaciones;
        this.flujoVentaPasoTiposPersonas = naturaleza;
        this.flujoVentaPasoOcupaciones = ocupaciones;
        this.flujoVentaPasoAdjunto = adjunto;
        if ( this.flujoVentaPasoAdjunto && this.flujoVentaPasoAdjunto.indicadorHabilitado ) {
          this.cargarAdjunto( this.flujoVentaPasoAdjunto );
        }
        this.setFormData();
        this.cargando = false;
      } );
    } else {
      this.flujoVentaPasoAdjunto = null;
      this.flujoVentaPasoVinculaciones = [];
      this.flujoVentaPasoTiposPersonas = [];
      this.flujoVentaPasoOcupaciones = [];
      this.setFormData();
      this.cargando = false;
    }
  }

  conectarCanal() {
    this.suscripcionCambioSecuencia = this.componentCommService.emisorComponent$.subscribe( r => {
      if ( r.canal === 'flujo-venta' && this.formFlujoVentaPaso && r.mensaje && !!r.mensaje.find( x => x === this.tabView.codigo ) ) {
        this.f.secuencia.setValue( this.tabView.flujoVenta ? this.tabView.flujoVenta.secuencia : null );
        this.secuenciaVieja = this.tabView.flujoVenta.secuencia;
      }
    } );
  }

  private setFormData() {
    const vinculaciones = [];
    const naturaleza = [];
    const ocupaciones = [];
    this.flujoVentaPasoVinculaciones.forEach( e => {
      if ( e.indicadorHabilitado ) {
        vinculaciones.push( e.idTipoVinculacion );
      }
    } );
    this.flujoVentaPasoTiposPersonas.forEach( e => {
      if ( e.indicadorHabilitado ) {
        naturaleza.push( e.idTipoPersona );
      }
    } );
    this.flujoVentaPasoOcupaciones.forEach( e => {
      if ( e.indicadorHabilitado ) {
        ocupaciones.push( e.idTipoOcupacionConfiguracion );
      }
    } );
    this.formFlujoVentaPaso = this.fb.group( {
      idFlujoVentaPaso: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.idFlujoVentaPaso : null ],
      codigo: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.codigo : this.tabView.codigo, [ Validators.required ] ],
      nombre: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.nombre : null, [ Validators.required ] ],
      descripcion: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.descripcion : null ],
      secuencia: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.secuencia : ( this.secFija ? this.tabView.secuencia : null ), [ Validators.required ] ],
      idAdjunto: [ ( this.flujoVentaPasoAdjunto && this.flujoVentaPasoAdjunto.indicadorHabilitado ) ? this.flujoVentaPasoAdjunto.idAdjunto : null ],
      idVinculacion: [ vinculaciones, [ Validators.required ] ],
      indicadorHabilitado: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorHabilitado : true ],
      indicadorPasoPrincipal: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorPasoPrincipal : false ],
      indicadorGestorTerceros: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorGestorTerceros : false ],
      indicadorVinculacionPerfil: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorVinculacionPerfil : false ],
      indicadorPreaprobado: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorPreaprobado : false ],
      indicadorOcupacion: [ this.flujoVentaPasoModel ? this.flujoVentaPasoModel.indicadorOcupacion : false ],
      idsOcupacion: [ ocupaciones, this.flujoVentaPasoModel?.indicadorOcupacion ? [ Validators.required ] : [] ],
      idsNaturaleza: [ naturaleza, this.tabView.codigo === this.pasosEnum.FINPROCESO ? [] : [ Validators.required ] ],
    } );

    this.formFlujoVentaPaso.get( 'indicadorOcupacion' ).valueChanges.subscribe( value => {
      const ctrl = this.formFlujoVentaPaso.get( 'idsOcupacion' );
      if ( value ) {
        ctrl.setValidators( [ Validators.required ] );
      } else {
        ctrl.clearValidators();
        ctrl.setValue( [] );
      }
      ctrl.updateValueAndValidity();
    } );
  }

  cargarAdjunto( flujoPasoAdjunto: FlujoVentaPasoAdjunto ) {
    this.subAdjunto = true;
    this.adjService.descargarArchivo( flujoPasoAdjunto.idAdjunto ).subscribe( adjunto => {
      this.nomArchivo = flujoPasoAdjunto.nombreArchivo;
      this.file = adjunto;
      this.cargarReaderImagen( adjunto );
      this.subAdjunto = false;
    }, error => {
      this.subAdjunto = false;
    } );
  }

  onSubmit() {
    this.formSubmitted = true;
    if ( this.formFlujoVentaPaso.invalid ) {
      scrollToFirstInvalidControl( this.formFlujoVentaPaso, this.flujoVentaFormRef.nativeElement );
    }
    if ( this.formFlujoVentaPaso.valid ) {
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_GUARDAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'form-paso-flujo-' + this.tabView.codigo,
        accept: () => {
          this.guardarInformacionFlujoVentaPaso();
        },
        reject: () => {
          this.guardando = false;
        }
      } );
    }
  }

  private guardarInformacionFlujoVentaPaso() {
    // Antes de guardar verificar si es posible mover la secuencia del tab en curso
    // Verificar si es guardar o modificar
    this.asignarValoresModeloFlujoVentaPaso();
    let validar = null;
    let index = 0;
    if ( this.secuenciaVieja && Number( this.f.secuencia.value ) !== this.secuenciaVieja ) {
      validar = this.flujoVentaPasoService.validarMovimiento( this.f.secuencia.value, this.secuenciaVieja, this.lisPasos, this.tabView.codigo );
    }

    if ( !validar || validar.estado ) {
      const peticiones = [];
      if ( this.flujoVentaPasoModel && !this.flujoVentaPasoModel.idFlujoVentaPaso ) {
        this.file = this.tempFile;
        this.flujoVentaPasoService.crear( this.flujoVentaPasoModel ).subscribe( res => {
          this.flujoVentaPasoModel = res;
          this.notifySequenceChange( false, this.f.secuencia.value, this.secuenciaVieja, this.tabView.codigo );
          const vinculacionesRegistrar = this.asignarValoresModeloFlujoVentaPasoVinculacion();
          const naturaleza = this.asignarValoresModeloFlujoVentaPasoTipoPersonas();
          const ocupaciones = this.asignarValoresModeloFlujoVentaPasoOcupaciones();
          this.asignarValoresModeloFlujoVentaPasoAdjunto();
          peticiones.push( this.flujoVentaPasoVinculacionService.bulk( vinculacionesRegistrar ) );
          if(naturaleza.length > 0) {
            peticiones.push( this.flujoVentaPasoTiposPersonasService.bulk( naturaleza ) );
          }
          if ( ocupaciones.length > 0 ) {
            peticiones.push( this.flujoVentaPasoOcupacionService.bulk( ocupaciones ) );
          }

          if ( this.flujoVentaPasoAdjunto ) {
            peticiones.push( this.flujoVentaPasoAdjuntoService.crear( this.flujoVentaPasoAdjunto ) );
          }
          forkJoin(
            peticiones
          ).subscribe( ( response: any[] ) => {

            this.flujoVentaPasoVinculaciones = response[index++] as any;
            if (naturaleza.length > 0) {
              this.flujoVentaPasoTiposPersonas = response[index++]  as any;
            }
            if ( ocupaciones.length > 0 ) {
              this.flujoVentaPasoOcupaciones = response[index++] as any;
            }

            this.flujoVentaPasoAdjunto =  response[index++] as any;
            this.flujoVentaPasoAdjunto.nombreArchivo = this.nomArchivo;

            this.secuenciaVieja = this.flujoVentaPasoModel.secuencia;
            this.showMessage( 'Exito', 'Se ha guardado la información del paso correctamente!', 'success' );
            this.formSubmitted = false;
            this.setFormData();
            this.formFlujoVentaPaso.markAsPristine();
            if ( this.esAcordeon ) {
              this.goNextAccordion.emit( this.flujoVentaPasoModel );
            }
          } );
        } );
      } else {
        this.file = this.tempFile;
        this.flujoVentaPasoService.actualizar( this.flujoVentaPasoModel ).subscribe( res => {
          this.flujoVentaPasoModel = res;
          this.notifySequenceChange( true, this.f.secuencia.value, this.secuenciaVieja, this.tabView.codigo );
          const vinculacionesRegistrar = this.asignarValoresModeloFlujoVentaPasoVinculacion();
          const naturaleza = this.asignarValoresModeloFlujoVentaPasoTipoPersonas();
          const ocupaciones = this.asignarValoresModeloFlujoVentaPasoOcupaciones();
          this.asignarValoresModeloFlujoVentaPasoAdjunto();
          peticiones.push( this.flujoVentaPasoVinculacionService.bulk( vinculacionesRegistrar ) );
          if ( naturaleza.length > 0 ) {
            peticiones.push( this.flujoVentaPasoTiposPersonasService.bulk( naturaleza ) );
          }
          if ( ocupaciones.length > 0 ) {
            peticiones.push( this.flujoVentaPasoOcupacionService.bulk( ocupaciones ) );
          }

          if ( this.flujoVentaPasoAdjunto ) {
            peticiones.push( this.flujoVentaPasoAdjuntoService.actualizar( this.flujoVentaPasoAdjunto ) );
          }
          forkJoin(
            peticiones
          ).subscribe( ( response: any[] ) => {


            this.flujoVentaPasoVinculaciones = response[index++] as any;
            if (naturaleza.length > 0) {
              this.flujoVentaPasoTiposPersonas = response[index++] as any;
            }
            if ( ocupaciones.length > 0 ) {
              this.flujoVentaPasoOcupaciones = response[index++] as any;
            }
            this.flujoVentaPasoAdjunto = response[index++] as any;
            this.flujoVentaPasoAdjunto.nombreArchivo = this.nomArchivo;

            this.secuenciaVieja = this.flujoVentaPasoModel.secuencia;
            this.showMessage( 'Exito', 'Se ha actualizado la información del paso correctamente!', 'success' );
            this.formSubmitted = false;
            this.setFormData();
            this.formFlujoVentaPaso.markAsPristine();
            if ( this.esAcordeon ) {
              this.goNextAccordion.emit( this.flujoVentaPasoModel );
            }
            this.tabView.flujoVenta.indicadorVinculacionPerfil = this.f.indicadorVinculacionPerfil.value;
          } );
        } );
      }
    } else {
      this.showMessage( 'Información', validar.mensaje, 'info' );
    }
  }

  private asignarValoresModeloFlujoVentaPaso() {
    this.flujoVentaPasoModel = this.formFlujoVentaPaso.value as FlujoVentaPaso;
  }

  private asignarValoresModeloFlujoVentaPasoVinculacion() {
    const vincCrear = this.formFlujoVentaPaso.value;
    const vinculacionesAgregar = [];
    if ( vincCrear.idVinculacion ) {
      vincCrear.idVinculacion.map( s => {
        const exist = this.flujoVentaPasoVinculaciones.find( x => x.idTipoVinculacion === s );
        let regAgregar;
        if ( exist ) {
          regAgregar = exist;
          regAgregar.indicadorHabilitado = true;
        } else {
          regAgregar = {} as FlujoVentaPasoVinculacion;
          regAgregar.idFlujoVentaPaso = this.flujoVentaPasoModel.idFlujoVentaPaso;
          regAgregar.indicadorHabilitado = true;
          regAgregar.idTipoVinculacion = s;
        }
        vinculacionesAgregar.push( regAgregar );
      } );

      this.flujoVentaPasoVinculaciones.map( vinc => {
        const temp = vinculacionesAgregar.find( x => x.idTipoVinculacion === vinc.idTipoVinculacion );
        if ( !temp ) {
          const regAgregar = vinc;
          regAgregar.indicadorHabilitado = false;
          vinculacionesAgregar.push( regAgregar );
        }
      } );
    }

    return vinculacionesAgregar;
  }

  private asignarValoresModeloFlujoVentaPasoTipoPersonas() {
    const _dataTipoPersona = this.formFlujoVentaPaso.value;
    const lista = [];
    if ( _dataTipoPersona.idsNaturaleza ) {
      _dataTipoPersona.idsNaturaleza.map( s => {
        const _buscarReg = this.flujoVentaPasoTiposPersonas.find( x => x.idTipoPersona === s );
        let regAgregar;
        if ( _buscarReg ) {
          regAgregar = _buscarReg;
          regAgregar.indicadorHabilitado = true;
        } else {
          regAgregar = {} as FlujoVentaPasoTiposPersonas;
          regAgregar.idFlujoVentaPaso = this.flujoVentaPasoModel.idFlujoVentaPaso;
          regAgregar.indicadorHabilitado = true;
          regAgregar.idTipoPersona = s;
        }
        lista.push( regAgregar );
      } );

      this.flujoVentaPasoTiposPersonas.map( nat => {
        const temp = lista.find( x => x.idTipoPersona === nat.idTipoPersona );
        if ( !temp ) {
          nat.indicadorHabilitado = false;
          lista.push( nat );
        }
      } );
    }

    return lista;
  }

  private asignarValoresModeloFlujoVentaPasoOcupaciones() {
    const _data = this.formFlujoVentaPaso.value;
    const lista = [];
    if ( _data.idsOcupacion ) {
      _data.idsOcupacion.map( s => {
        const existe = this.flujoVentaPasoOcupaciones.find( x => x.idTipoOcupacionConfiguracion === s );
        let regAgregar;
        if ( existe ) {
          regAgregar = existe;
          regAgregar.indicadorHabilitado = true;
        } else {
          regAgregar = {} as FlujoVentaPasoOcupacion;
          regAgregar.idFlujoVentaPaso = this.flujoVentaPasoModel.idFlujoVentaPaso;
          regAgregar.indicadorHabilitado = true;
          regAgregar.idTipoOcupacionConfiguracion = s;
        }
        lista.push( regAgregar );
      } );

      this.flujoVentaPasoOcupaciones.map( ocu => {
        const temp = lista.find( x => x.idTipoOcupacionConfiguracion === ocu.idTipoOcupacionConfiguracion );
        if ( !temp ) {
          ocu.indicadorHabilitado = false;
          lista.push( ocu );
        }
      } );
    }
    return lista;
  }

  private asignarValoresModeloFlujoVentaPasoAdjunto() {
    if ( this.flujoVentaPasoAdjunto ) {
      this.flujoVentaPasoAdjunto.idAdjunto = this.f.idAdjunto.value ? this.f.idAdjunto.value : this.flujoVentaPasoAdjunto.idAdjunto;
      this.flujoVentaPasoAdjunto.indicadorHabilitado = this.f.idAdjunto.value ? true : false;
    } else {
      let adjuntoAgregar = null;
      if ( this.f.idAdjunto.value ) {
        adjuntoAgregar = {
          idAdjunto: this.f.idAdjunto.value,
          indicadorHabilitado: true,
          idFlujoVentaPaso: this.flujoVentaPasoModel.idFlujoVentaPaso,
          auditoriaFecha: null
        } as FlujoVentaPasoAdjunto;
      }

      this.flujoVentaPasoAdjunto = adjuntoAgregar;
    }
  }

  eliminarAdjunto() {
    this.f.idAdjunto.setValue( null );
    this.f.idAdjunto.markAsDirty();
    this.nomArchivo = null;
    this.imagen = null;
    this.submitAdjunto = false;
  }

  onBeforeSend( event: any ) {
    this.subAdjunto = true;
    this.adjService.cargarArchivo( event, this.nomArchivo, 'ValidacionIdentidad' );
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.f.idAdjunto.setValue( respuesta.idAdjunto );
      // this.flujoVentaPasoAdjunto.idAdjunto = respuesta.idAdjunto;
      this.subAdjunto = false;
    } else {
      this.f.idAdjunto.setValue( null );
      // this.flujoVentaPasoAdjunto.idAdjunto = null;
      this.subAdjunto = false;
    }
  }

  onSelect( event: any, file: any ) {
    this.nomArchivo = file[ 0 ].name;
    this.tempFile = file[ 0 ];
    this.cargarReaderImagen( file[ 0 ] );
  }

  cancelar( formDirty: boolean ) {
    if ( formDirty || this.f.idAdjunto.value !== this.flujoVentaPasoAdjunto.idAdjunto ) {
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'form-paso-flujo-' + this.tabView.codigo,
        accept: () => {
          this.cancelarEdicion();
        },
        reject: () => {
          this.guardando = false;
        }
      } );
    } else {
      this.cancelarEdicion();
    }
  }

  cancelarEdicion() {
    this.cargando = true;
    this.formSubmitted = false;
    this.setFormData();
    this.formFlujoVentaPaso.markAsPristine();
    this.nomArchivo = null;
    this.imagen = null;
    this.subAdjunto = false;
    if ( this.flujoVentaPasoAdjunto && this.flujoVentaPasoAdjunto.indicadorHabilitado ) {
      this.cargarReaderImagen( this.file );
      this.nomArchivo = this.flujoVentaPasoAdjunto.nombreArchivo;
    }

    if ( this.showControlesTable ) {
      this.realizarBusquedaDatatable.next( null );
    }
    setTimeout( () => this.cargando = false, 500 );
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navService.setMesage( 0, {
      severity: severity, summary: this.navService.buscarMensaje( titulo ),
      detail: this.navService.buscarMensaje( mensaje ), key: 'form-paso-flujo'
    } );
  }

  ngOnDestroy(): void {
    if ( this.suscripcionCambioSecuencia ) {
      this.suscripcionCambioSecuencia.unsubscribe();
    }
  }

  notifySequenceChange( actualizar: boolean, nuevoIndice: number, antiguoIndice: number, codigo: string ) {
    this.componentCommService.emitir( {
      canal: 'flujo-venta-actualizo',
      mensaje: { actualizar: actualizar, nuevoIndice: nuevoIndice, antiguoIndice: antiguoIndice, codigo: codigo }
    } );
  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen =  this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  protected readonly pasosEnum = Pasos;
}
